<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 账号管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-table
                    :data="tableData"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="系统ID" prop="Id" sortable></el-table-column>
                <el-table-column align="center" label="登录账号" prop="Uemail" sortable width="265"></el-table-column>
                <el-table-column align="center" label="姓名" prop="Uname" sortable></el-table-column>
                <el-table-column align="center" label="昵称" prop="Usn" sortable></el-table-column>
                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '销售', value: '1' }, { text: '管理员', value: '2' }, { text: '超级管理员', value: '7' }]"
                                 align="center"
                                 label="角色"
                                 prop="Urole">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Urole===1?'success':(scope.row.Urole===2?'info':'danger')"
                        >
                            {{scope.row.Urole===1?'销售':(scope.row.Urole===2?'管理员':'超级管理员')}}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column align="center" label="上次登录时间" prop="Ulast_time"></el-table-column>
                <el-table-column align="center" label="上次登录ip" prop="Ulast_ip"></el-table-column>
                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '被禁用', value: '0' }, { text: '正常', value: '1' }]"
                                 align="center"
                                 label="状态"
                                 prop="Ustate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Ustate===0?'danger':'success'"
                        >
                            {{scope.row.Ustate===0?'已禁用':'正常'}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="editorArea(scope.$index, scope.row)"
                                icon="el-icon-picture-outline"
                                type="text"
                        >拥有城市
                        </el-button>

                    </template>
                </el-table-column>
            </el-table>


            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 弹出框@编辑 用户详情信息 -->
        <el-dialog :visible.sync="edit_info_vis" title="用户信息" width="50%">
            <el-form :model="form" label-width="90px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="用户Email：">{{form.Uemail}}</el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="系统ID：">{{form.Id}}</el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="用户密码：">
                            <el-input clearable v-model="form.Upass"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-button @click="updateUserPwd" plain type="primary">修改密码</el-button>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="用户姓名：">
                            <el-input clearable v-model="form.Uname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="用户昵称：">
                            <el-input clearable v-model="form.Usn"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">

                    <el-col :span="10">
                        <el-form-item label="用户状态：">
                            <el-select placeholder="请选择" v-model="form.Ustate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in stateOpt"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="用户角色：">
                            <el-select placeholder="请选择" v-model="form.Urole">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in roleOpt"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="登录时间：">{{form.Ulast_time}}</el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="登录IP：">{{form.Ulast_ip}}</el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="edit_info_vis = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 弹出框@编辑 用户拥有省份信息 -->
        <el-dialog :visible.sync="edit_area_vis" title="用户省份信息" width="50%">
            <el-transfer
                    :titles="['所有省份', '拥有省份']"
                    v-model="area"
                    :data="province">
            </el-transfer>
            <span class="dialog-footer" slot="footer">
                <el-button @click="edit_area_vis = false">取 消</el-button>
                <el-button @click="saveArea" type="primary">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                query: {
                    pageIndex: 1,
                    pageSize: 10
                },
                edit_info_vis: false,
                edit_area_vis: false,
                stateOpt: [{
                    value: 0,
                    label: '账号被封'
                }, {
                    value: 1,
                    label: '正常'
                }],
                roleOpt: [{
                    value: 1,
                    label: '销售'
                }, {
                    value: 2,
                    label: '管理员'
                }, {
                    value: 7,
                    label: '超级管理员'
                }],

                province:[],
                area:[],

                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1
            };
        },
        created() {
            this.getUserData();
        },
        methods: {

            //2026 初始化 用户列表数据
            async getUserData() {
                const { data: res } = await this.$http.post('admin/partner/pageUsers', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取用户列表数据失败，请联系管理员!');
                }
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = true;
                this.$message.success('【用户列表数据】加载成功!');
            },

            //2026  分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getUserData();
            },

            //2026  编辑用户信息操作
            async handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.edit_info_vis = true;
                // this.getTickets(this.form.Opid)
            },

            //2026 保存用户拥有地区信息
            async saveArea() {
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/partner/saveArea', {
                    uid: this.form.Id,
                    area: this.area
                });
                if (res.code !== 200) {
                    this.edit_info_vis = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.province = res.provinceList;
                this.area = res.areaList;
                this.$message.success(res.message);
                this.edit_info_vis = false;
            },

            //2026 保存用户信息
            async saveEdit() {
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/partner/updateUser', {
                    Uid: this.form.Id,
                    Uname: this.form.Uname,
                    Usn: this.form.Usn,
                    Ustate: this.form.Ustate,
                    Urole: this.form.Urole
                });
                if (res.code !== 200) {
                    this.edit_info_vis = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.edit_info_vis = false;
                //  this.form=[];
            },

            //2026 更改 密码信息
            async updateUserPwd() {
                if (this.form.Upass < 4) {
                    return this.$message.error('请输入密码，长度大于3！');
                } else {
                    const { data: res } = await this.$http.post('admin/partner/updateUserPwd', {
                        Upasswd: this.form.Upass,
                        Uid: this.form.Id
                    });
                    if (res.code === 200) {
                        this.$message.success(res.message + '，下次登录需新密码!');
                    }
                }
            },

            // 2026 用户拥有省份城市信息
            async editorArea(index, row) {
                this.idx = index;
                this.form = row;
                this.edit_area_vis = true;
                const { data: res } = await this.$http.post('/admin/partner/getProvinceUserArea', {
                    uid: this.form.Id
                });
                this.province = res.provinceList;
                this.area = res.areaList;
            },

            //2026 标签筛选
            filterTag(value, row) {
                return row.Ustate == value;
            }
        }
    };
</script>

<style scoped>



    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd100 {
        width: 90px;
    }

    .wd400 {
        width: 400px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
